import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { validate } from '@adornis/validation/decorators.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { LearningContentAPI } from '@chancenwerk/campus-learning-content/api/LearningContentAPI.js';
import { ScopedEntity } from '../../db/ScopedEntity.js';
import { CampusExercise } from './CampusExercise.js';
import { CampusSection } from './CampusSection.js';

@Entity()
export class CampusLesson extends ScopedEntity {
  public static override _class = 'CampusLesson';
  public static override _collectionName = 'campus-lessons';

  static override get allFields() {
    return selectionSet(() => CampusLesson, 2);
  }

  @Field(type => [String], {
    default: v => v ?? [],
  })
  public exerciseIDs!: string[];

  @DataLoadedField(type => [CampusExercise], ({ exerciseIDs }) => exerciseIDs)
  public exercises!: CampusExercise[];

  @validate(({ value, key, source }) => {
    if (!value) throw new ValidationError(`Der Name der Lektion darf nicht leer sein!`, { key, source });
  })
  @Field(type => String, {
    default: v => v ?? '',
  })
  public name!: string;

  @Field(type => Boolean, {
    default: v => v ?? true,
  })
  public hiddenFromStudents!: boolean;

  @Field(type => [String], {
    default: v => v ?? [],
  })
  public attachementIDs!: string[];

  @Field(type => [String], {
    default: v => v ?? [],
  })
  public lessonIDsDependingOn!: string[];

  @Field(type => Int, {
    default: v => v ?? 0,
  })
  public sortingOrder!: number;

  public override async remove() {
    const section = await LearningContentAPI.getSectionForLesson(this._id)(CampusSection.allFields);
    if (!section) throw new Error('Section of lesson not found, this shouldnt happen');
    const indexOfRemovedLesson = section.lessonIDs?.findIndex(lessonID => lessonID === this._id) ?? -1;
    if (indexOfRemovedLesson !== -1) section.lessonIDs?.splice(indexOfRemovedLesson, 1);
    section.save();
    return super.remove();
  }
}
